<template>
  <K2Row space-between="true" align="center" class="K2Input" @onclick="copyText">
    <input :value="value" ref="inputToCopy" />
    <i class="material-icons" style="font-size: 18px; top: 0; width: 30px; text-align: center; cursor: pointer">content_copy</i>
  </K2Row>
</template>

<script>
import K2Row from '../k2Row/k2Row'

export default {
  name: 'K2CopyInput',
  components: { K2Row },
  props: ['value'],
  methods: {
    async copyText() {
      if (this.value) {
        const input = this.$refs.inputToCopy
        input.select()
        input.setSelectionRange(0, 99999) // For mobile devices

        document.execCommand('copy')
        input.setSelectionRange(0, 0) // Reset selection

        console.log('Text copied to clipboard')

        this.$notify.success({
          title: 'Copied',
          message: 'Copy Success...',
        })
      }
    },
  },
}
</script>
